import {enable301ResponseState} from "@pg-mono/response-state";
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpFeatureFlagSemanticSearch} from "../../app/read_rp_environment_variables";
import {IAppDispatch} from "../../store/store";

export function semanticSearchAction() {
    return async (dispatch: IAppDispatch) => {
        const isSemanticSearchEnabled = rpFeatureFlagSemanticSearch;

        if (!isSemanticSearchEnabled) {
            dispatch(enable301ResponseState(rpAppPath.base));
            return false;
        }
    };
}
import {enable301ResponseState} from "@pg-mono/response-state";
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpFeatureFlagSemanticSearch} from "../../app/read_rp_environment_variables";
import {IAppDispatch} from "../../store/store";

export function semanticSearchAction() {
    return async (dispatch: IAppDispatch) => {
        const isSemanticSearchEnabled = rpFeatureFlagSemanticSearch;

        if (!isSemanticSearchEnabled) {
            dispatch(enable301ResponseState(rpAppPath.base));
            return false;
        }
    };
}
